import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {InsolesModel} from '../../../api/model/insoles.model';

@Injectable()
export class InsolesRepository extends AbstractRepositoryV2<InsolesModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Insoles', serviceElementsFactory, injector);
    }
}
